/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ViolationsDetectionNotificationArguments {
  /**
  * The resource IDs of the backup policy
  */
  'resourceIds'?: Array<string>;
  /**
  * The total number of resources that violation detection status has been changed
  */
  'totalResources'?: number;
  /**
  * Whether the violation detection status has been changed to detected
  */
  'detected'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceIds",
      "baseName": "resourceIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "totalResources",
      "baseName": "totalResources",
      "type": "number",
      "format": ""
    },
    {
      "name": "detected",
      "baseName": "detected",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ViolationsDetectionNotificationArguments.attributeTypeMap;
  }

  public constructor() {
  }
}

